export default {
  title: 'Faturas',
  form: {
    auto_generate_invoices: {
      label: 'Gerar faturas automaticamente',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    failed_to_save_changes: 'Erro ao guardar as alterações',
    changes_got_saved: 'Alterações guardadas',
  },
};
